var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detailed-info-block"},[_c('AlertIcon',{staticClass:"detailed-info-block__icon"}),_c('div',{staticClass:"detailed-info-block__info",domProps:{"innerHTML":_vm._s(_vm.formatText(_vm.info))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }